module.exports = __webpack_public_path__ + "img/_ico_alrim_on.e11d3278.svg";